<template>
  <div class="container">
    <template v-if="isLargeScreen === true">
      <GCVideo autoplay loop muted preload="auto" :controls="false" x5-video-player-type="h5" webkit-playsinline="true"
        x-webkit-airplay="true" playsinline="true" poster="" x5-playsinline disablepictureinpicture
        disableremoteplayback src="https://p4-ky.wsukwai.com/kos/nlav12119/DvQDfHrG_2024-07-03-20-09-25.mp4"></GCVideo>
    </template>
    <template v-else>
      <GCVideo autoplay loop muted preload="auto" :controls="false" x5-video-player-type="h5" webkit-playsinline="true"
        x-webkit-airplay="true" playsinline="true" poster="" x5-playsinline disablepictureinpicture
        disableremoteplayback src="https://p4-ky.wsukwai.com/kos/nlav12119/YUaIyvpr_2024-07-09-18-54-04.mp4"></GCVideo>
    </template>
  </div>
</template>

<script setup lang="ts">
import GCVideo from './common/GCVideo.vue';


const isLargeScreen = ref(false);

const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})

</script>
<style scoped lang="less">
.container {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.2);

  video {
    width: 100%;
    height: 100%;

    @media screen and (max-width:1360px) {
      height: 8.96rem;
      aspect-ratio: 1280 / 720;
      object-fit: cover;
    }
  }
}
</style>
